module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_intro-heading01-aa54356d51650d3caa6ee08ce09a4406.png";